module.exports = __webpack_public_path__ + "media/images/U-100-only-ecee362cabab031280134cb7e4855381.svg";